(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-wrapper.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-wrapper.js');
"use strict";

const {
  createContext,
  useContext
} = React;

const GameContext = createContext();
const useGameContext = () => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGameContext must be used within a GameContext.Provider');
  }
  return context;
};
setGlobal('svs.ticketgames.ticketUtility.components.useGameContext', useGameContext);
setGlobal('svs.ticketgames.ticketUtility.components.GameContext', GameContext);
setGlobal('svs.ticketgames.ticketUtility.components.GameWrapper', _ref => {
  let {
    children,
    className = '',
    context,
    styles
  } = _ref;
  return React.createElement(GameContext.Provider, {
    value: context
  }, React.createElement("div", {
    className: "".concat(className, " relative overflow-hidden"),
    style: styles
  }, children));
});

 })(window);